import React, { useState, useRef, useEffect } from "react";

export const Features = (props) => {
  const featureRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (featureRef.current) {
        const rect = featureRef.current.getBoundingClientRect();
        
        // Điều chỉnh điều kiện để phát hiện phần tử nằm trong viewport
        if (rect.top <= 500) {
          setIsActive(true);
        } else {
          setIsActive(false);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => { 
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div id="features" ref={featureRef}>
        <div className="container">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.title}-${i}`} className={`col-xs-12 col-md-4 feature ${isActive ? 'feature-active' : ''}`}>
                {" "}
                <i className={d.icon}></i>
                <h3>{d.title}</h3>
                <p>{d.text}</p>
              </div>
              ))
              : "Loading..."}
        </div>
      </div>
  );
};
